// removed by extract-text-webpack-plugin
module.exports = {"card":"TaskTemplateListCard__card__3o6ef","titleWrapper":"TaskTemplateListCard__titleWrapper__dNziR","cardImage":"TaskTemplateListCard__cardImage__2kRCR","title":"TaskTemplateListCard__title__1eHY9"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Pages/TaskTemplateListOverview/TaskTemplateListView/TaskTemplateListCard/TaskTemplateListCard.scss
// module id = 1936
// module chunks = 0